import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

// Returnerar bara belopp med två decimaler, ingen valutakod eller symbol
export const formatPrice = (amount: number) => {
  return amount.toFixed(2);
};
